/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import Image from '@tiptap/extension-image';
import { mergeAttributes } from '@tiptap/core';

export default Image.extend({
  name: 'comms-image',

  addAttributes() {
    return {
      ...Image.config.addAttributes(),
      size: {
        default: 'small',
        rendered: false
      },
      style: {
        default: 'float: none',
        rendered: true
      },
      float: {
        default: 'none',
        rendered: true
      },
      width: {
        default: '200px',
        rendered: true
      }
    };
  },

  addCommands() {
    return {
      setImage: (options) => ({ tr, commands }) => {
        if (tr.selection?.node?.type?.name === 'comms-image') {
          return commands.updateAttributes('comms-image', options);
        }

        return commands.insertContent({
          type: this.name,
          attrs: options
        });
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    HTMLAttributes.class = ` comms-image-${ node.attrs.size}`;
    HTMLAttributes.class += ` comms-image-float-${ node.attrs.float}`;

    return [
      'img',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
    ];
  }
});
